module.exports = __webpack_public_path__ + "static/media/grocery.24f13d0a.PNG";